import React, { FC, useState, useEffect, useCallback } from 'react';
import { Placement } from 'popper.js';
import { Callout } from 'components/layout/Callout';
import { PropertyGrid } from 'components/property-editors/PropertyGrid';
import { ContextProviderNode } from '@decisions/server/DecisionsFramework/Design/Properties';
import { registerEditorAndGetSnapshot } from '@decisions/server/DecisionsFramework/Design/Properties/ContextProviderService';
import { ButtonPanel } from 'components/Dialogs/ButtonPanel';

export interface IIntegrationSettingsLayer {
  onClose: () => void;
  sourceRef: React.MutableRefObject<HTMLElement | any>;
  placement?: Placement;
  getEditingContextId?: () => Promise<string>;
  category: string;
}

export const DesignerPromptLayer: FC<IIntegrationSettingsLayer> = (props: IIntegrationSettingsLayer) => {
  const [snapshot, setSnapshot] = useState<ContextProviderNode | undefined>(undefined);
  const { getEditingContextId, onClose } = props;

  const getSnapshot = useCallback(async () => {
    if (getEditingContextId) {
      const id = await getEditingContextId();
      const snapshot = await registerEditorAndGetSnapshot({ contextProviderRegistrationId: id });
      setSnapshot(snapshot);
    }
  }, [getEditingContextId]);

  useEffect(() => {
    getSnapshot();
  }, [getSnapshot]);

  return (
    <>
      {snapshot !== undefined && (
        <Callout
          className="dp-designer-prompt-layer"
          isOpen={true}
          onClose={onClose}
          sourceRef={props.sourceRef}
          placement={props.placement ? props.placement : 'bottom-end'}
          showArrow={true}
          flipBehavior={['bottom', 'left']}
        >
          <div className="dp-designer-prompt-layer__editor">
            <PropertyGrid
              snapshot={snapshot}
              categoryToRender={props.category}
              hideTopCategory={true}
              hideSearch={true}
            />
          </div>
          <ButtonPanel className="dp-designer-prompt-layer__footer" actions={[{ name: 'Done', onClick: onClose }]} />
        </Callout>
      )}
    </>
  );
};
